const thTH = {
  // Claim Forms
  'claimForms.title': 'แบบฟอร์มการเรียกร้อง',
  'claimForms.photoTooSmall': 'ภาพมีขนาดเล็กเกินไป ขั้นต่ำ 10kb',
  'claimForms.photoTooLarge': 'ภาพมีขนาดใหญ่เกินไป สูงสุด 5mb',
  'claimForms.videoTooLarge': 'วิดีโอมีขนาดใหญ่เกินไป สูงสุด 10mb',
  'claimForms.maxFilesExceeded': 'ไม่สามารถอัปโหลดไฟล์เกิน 50 ไฟล์',
  'claimForms.fileAlreadyUploaded': 'ไฟล์นี้ถูกอัปโหลดแล้ว',
  'claimForms.uploadError': 'เกิดข้อผิดพลาด โปรดโหลดใหม่และลองอีกครั้ง',
  'claimForms.checkFileType': 'ตรวจสอบประเภทไฟล์ของคุณ',
  'claimForms.allowedFileTypes': 'อนุญาตเฉพาะไฟล์ประเภท .jpg, .jpeg, .pdf, .png, .mp4, .mov และ .avi เท่านั้น',
  'claimForms.error': 'ข้อผิดพลาด',
  'claimForms.saved': 'บันทึกแล้ว',
  'claimForms.saveDraft': 'บันทึกฉบับร่าง',
  'claimForms.save': 'บันทึก',
  'claimForms.select': 'เลือก ...',
  'claimForms.agreeWith': 'ฉันยอมรับ',
  'claimForms.termsAndConditions': 'ข้อกำหนดและเงื่อนไข',
  'claimForms.fieldRequired': '{field} จำเป็นต้องกรอก',
  'claimForms.viewFile': 'ดูไฟล์',
  'claimForms.uploadFile': 'อัปโหลดไฟล์',
  'claimForms.changeFile': 'เปลี่ยนไฟล์',
  'claimForms.uploading': 'กำลังอัปโหลด...',
  'claimForms.reupload': 'อัปโหลดใหม่',
  'claimForms.agree': 'ยอมรับ',
  'claimForms.tcStatement1': 'ข้าพเจ้า / เราขอประกาศว่าข้อมูลทั้งหมดที่ให้ไว้ข้างต้นเป็นความจริงตามความรู้และความเชื่อของข้าพเจ้า / เรา',
  'claimForms.tcStatement2': 'ข้าพเจ้า / เราตกลงที่จะให้อำนาจเต็มแก่ PT. Asuransi Simas Insurtech ในการตรวจสอบและสำรวจหากจำเป็น',
  'claimForms.tcStatement3': 'ข้าพเจ้า / เราตกลงว่าหากข้าพเจ้า / เราให้ข้อความเท็จ / ฉ้อฉลที่เกี่ยวข้องกับการเรียกร้องหรือซ่อนเร้นข้อเท็จจริงที่สำคัญในรูปแบบใด ๆ ที่ส่งผลให้กรมธรรม์ถูกยกเลิกและสูญเสียสิทธิ์การเรียกร้องในปัจจุบันและในอนาคต',
  // Create Claim
  'createClaim.title': 'สร้างการเรียกร้อง',
  'createClaim.success': 'สำเร็จ',
  'createClaim.error': 'ข้อผิดพลาด',
  'createClaim.uploadPhotoError': 'เกิดข้อผิดพลาดในการอัปโหลดรูปภาพ',
  'createClaim.getBenefitsError': 'เกิดข้อผิดพลาดในการรับรายการสิทธิประโยชน์',
  'createClaim.validationFailed': 'การตรวจสอบล้มเหลว',
  'createClaim.loading': 'กำลังโหลด...',
  'createClaim.noBenefitsFound': 'ไม่พบสิทธิประโยชน์',
  'createClaim.next': 'ถัดไป'
}

export default thTH
